export const UPDATE_MODULES = 'UPDATE_MODULES';
export const CURRENT_USER = 'CURRENT_USER';
export const UPDATE_AREAS = 'UPDATE_AREAS';
export const UPDATE_DATAGROUPS ='UPDATE_DATAGROUPS';

export const CURRENT_BUSINESS = 'CURRENT_BUSINESS';
export const CURRENT_BUSINESSLIST='CURRENT_BUSINESSLIST';
export const SELECT_AREA = 'SELECT_AREA';
export const SELECT_BOARD = 'SELECT_BOARD';
export const ALLBOARDS_BUSINESS='ALLBOARDS_BUSINESS';
export const ALLPIPELINES_BUSINESS='ALLPIPELINES_BUSINESS';
export const UPDATE_ACTUALTEAMS='UPDATE_ACTUALTEAMS';
export const UPDATE_ACTUALBRANCHS='UPDATE_ACTUALBRANCHS';
export const SET_ACTUALBRANCH='SET_ACTUALBRANCH';


export const GET_TEAMS='GET_TEAMS';
export const GET_BRANCHS='GET_BRANCHS';

export const SELECTED_TEAM="SELECTED_TEAM";

export const UPDATE_SCHEMES="UPDATE_SCHEMES";

export const UPDATE_ACTUALSCHEME='UPDATE_ACTUALSCHEME';


export const UPDATE_PACKLIST="UPDATE_PACKLIST";
export const UPDATE_PACKDATA="UPDATE_PACKDATA";



export const ADDNEW_AREA="ADDNEW_AREA";
export const ADDNEW_DATAGROUP="ADDNEW_DATAGROUP";

export const BUSINESS_MEMBERS="BUSINESS_MEMBERS";
export const ADDBUSINESS_MEMBERS="ADDBUSINESS_MEMBERS";

export const SET_NOTIFICATIONS="SET_NOTIFICATIONS";

export const START_LOADER="START_LOADER";
export const FINISH_LOADER="FINISH_LOADER";

export const ERROR_MESSAGE="ERROR_MESSAGE";
export const UPDATE_INTEGRATIONS="UPDATE_INTEGRATIONS";
export const UPDATE_INTEGRATIONSHUB="UPDATE_INTEGRATIONSHUB";

export const UPDATE_SHARELINKDETAIL="UPDATE_SHARELINKDETAIL";
export const UPDATE_TARGETLIST="UPDATE_TARGETLIST"
export const SET_TARGETLIST="SET_TARGETLIST"
export const SET_COLORTAGS="SET_COLORTAGS"
export const UPDATE_COLORTAGS="UPDATE_COLORTAGS"

export const UPDATE_ACTUALPACKDATA="UPDATE_ACTUALPACKDATA"

export const SELECTPCARD="SELECTPCARD"
export const OPEN_COLUMNMODAL="OPEN_COLUMNMODAL"
export const SET_ACTUALPIPELINE="SET_ACTUALPIPELINE"


